// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"241":"test-view","529":"colosseum","587":"community","757":"game","809":"account","844":"drift"}[chunkId] || chunkId) + "." + {"234":"f19098c2","241":"e68ef1c1","529":"c3cb2dde","587":"c501a1d4","757":"8b80e9e6","809":"c913859a","844":"f7efdac6"}[chunkId] + ".css";
};